import type { ReactNode } from 'react';
import { cn } from '../cn.js';

interface GoalCardProps {
  title: string;
  tagline: string;
  icon?: ReactNode;
  selected?: boolean;
  onSelect?: () => void;
  className?: string;
}

/**
 * Large goal selection card used on the onboarding screen.
 * Aurora glow on the selected state.
 */
export function GoalCard({
  title,
  tagline,
  icon,
  selected = false,
  onSelect,
  className,
}: GoalCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'group flex w-full flex-col items-start gap-3 rounded-lg border p-6 text-left transition-all',
        'bg-gradient-to-b from-surface-2 to-surface-1',
        selected
          ? 'border-aurora/50 shadow-glow-aurora'
          : 'border-hairline hover:border-hairline-strong',
        className,
      )}
    >
      {icon && (
        <span
          className={cn(
            'flex h-[40px] w-[40px] items-center justify-center rounded-md border border-hairline',
            'bg-surface-3 text-aurora transition-colors',
            selected && 'border-aurora/40',
          )}
        >
          {icon}
        </span>
      )}
      <span className="font-display text-2xl leading-none text-ink-0">{title}</span>
      <span className="text-sm text-ink-1">{tagline}</span>
    </button>
  );
}
